import { render, staticRenderFns } from "./Blacklisted.vue?vue&type=template&id=74107a63&"
import script from "./Blacklisted.vue?vue&type=script&lang=js&"
export * from "./Blacklisted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports